
    import * as React from 'react';

    const Preorder16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M13.906 4.24l.174-2.67.748.048-.282 4.335-4.125-1.362.235-.712 2.695.89A6.25 6.25 0 1014.25 8h.749a7 7 0 11-1.094-3.76zM8.25 8.112h2.625V9H7.5V5h.75v3.111z" /></svg>
        </div>
      );
    };

    Preorder16.displayName = 'Preorder16';

    export default Preorder16;
  